import { styled } from 'theme'

export const Box = styled('div', {})
